
<div class="notification-box mx-2"  >
    <svg (click)="toggleNotifications()">
        <use href="assets/svg/icon-sprite.svg#notification"></use>
    </svg>
    <span class="badge rounded-pill badge-secondary" *ngIf="(unreadCount$ | async) > 0">{{ unreadCount$ | async }}</span>
    <div class="badge notification-content">
        <app-global-notification *ngIf="isOpen" [isOpen]="isOpen" ></app-global-notification>
    </div>
</div>